import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // this.events = {
        //     click: {
        //         openPopin: 'openPopin',
        //         closePopin: 'closePopin'
        //     }
        // }
    }

    init() {
        const mask = this.el.querySelector('.videocover_mask_inner');
        this.popin = this.el.querySelector('.videocover_popin');

        window.addEventListener('videocoverProgress', (e) => {
            const { target, progress } = e.detail;
            let p = Math.round(progress * 1000);
            p = Math.min(p, 500);
            mask.style.setProperty('--progress', p/1000);
        });
    }

    // openPopin() {
    //     this.popin.classList.add('-visible');
    //     this.call('stop', 'Scroll');
    //     if (this.el.querySelector('[data-module-player]')) {
    //         this.call('play', false, 'Player', this.el.querySelector('[data-module-player]').getAttribute('data-module-player'));
    //     }
    // }

    // closePopin() {
    //     this.popin.classList.remove('-visible');
    //     this.call('start', 'Scroll');
    //     if (this.el.querySelector('[data-module-player]')) {
    //         this.call('pause', false, 'Player', this.el.querySelector('[data-module-player]').getAttribute('data-module-player'));
    //     }
    // }
}
